export default "__VITE_ASSET__cc1ff739__"